// store/modules/flowAnalysis.js
const state = {
  flowAnalysisDetail: null,
};

const mutations = {
  SET_FLOW_ANALYSIS_DETAIL(state, data) {
    state.flowAnalysisDetail = data;
  },
};

const actions = {
  setFlowAnalysisDetail({ commit }, data) {
    commit('SET_FLOW_ANALYSIS_DETAIL', data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/flowAnalysis.js